import UserList from './UserList';
import UserEdit from './UserEdit';
import {AccountCircle} from "@mui/icons-material";
import UserCreate from "./UserCreate";
import UserShow from './UserShow';

export default {
    list: UserList,
    edit: UserEdit,
    create: UserCreate,
    show: UserShow,
    icon: AccountCircle,
};
